import request from '@/libs/request';
// 员工管理 ------------------

// 核销积分
export const DecrCreditByUser = (data) => request('DecrCreditByUser', data);

// 批量核销积分, 并查询批量处理状态
export const BatchDecrCredit = (data) => request('BatchDecrCredit', data);

// 查询员工列表
export const GetStaffInforRecord = (data) => request('GetStaffInforRecord', data);
